import { Constants } from '../_constants/constants';
import { BaseParameterDto } from './base-parameter-dto';

export class ForgotUserNameParameterDto extends BaseParameterDto {
  email: string;
  recaptchaToken: string;
  portalType: string = Constants.portalTypeCode;
}
